<template>
  <div class="node">
    <inside-header title="新建工单" />
    <van-form input-align="right" @submit="onSubmit">
      <van-cell-group>
        <van-field v-model="value" label="主题" name="title" placeholder="请输入主题"
          :rules="[{ required: true, message: '请输入主题' }]" />
      </van-cell-group>
      <van-field readonly clickable label="类型" :value="type" name="type" placeholder="请选择"
        :rules="[{ required: true, message: '请选择工单类型' }]" @click="showPicker = true" />
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
      </van-popup>
      <van-field v-model="message" rows="2" autosize label="描述" name="content" type="textarea" maxlength="100"
        placeholder="请输入你遇到的问题" show-word-limit :rules="[{ required: true, message: '请输入你遇到的问题' }]" />
      <van-field readonly label="附件">
        <template #input>
          <a-upload action="/api/index/file/uploadProtectedImage" name="image" :multiple="true" :headers="headers"
            accept="image/png,image/jpeg" :file-list="enclosureFileList" @change="uploadChange">
            <a-button>
              <a-icon type="upload" /> 点击上传
            </a-button>
          </a-upload>
        </template>
      </van-field>
      <div style="margin: 16px;text-align:center" class="btn-area">
        <van-button round block native-type="submit" style="background-color:#ff5c00;color:#fff">
          添加
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
import store from '@/store/'
export default {
  components: {
    InsideHeader
  },
  data() {
    return {
      value: '',
      columns: ['意见建议', '财务问题', '举报投诉', '其他'],
      type: '',
      showPicker: false,
      message: '',
      headers: {
        authorization: store.getters.token
      },
      // 上传附件图片
      attachment: [],
      reply_content: '',
      workOrderStatus: '',
      enclosureFileList: []
    }
  },
  created() { },
  methods: {
    onConfirm(value) {
      this.type = value
      this.showPicker = false
    },
    uploadChange(e) {
      const attachment = []
      e.fileList.forEach(item => {
        if (item.response !== undefined && item.response.status === 'success') {
          attachment.push(item.response.data)
        }
      })
      this.attachment = attachment
      this.enclosureFileList = e.fileList
      if (Array.isArray(e)) {
        return e
      }
      return e && e.fileList
    },
    onSubmit(values) {
      values.attachment = this.attachment
      console.log(values)
      this.$http({
        url: 'index/worksheet/create',
        method: 'post',
        data: values
      }).then(res => {
        if (res.status === 'success') {
          const _this = this
          this.$toast.success('提交工单成功')
          setTimeout(function () {
            _this.$router.push({ name: 'TeacherWorkOrder' })
          }, 2000)
        } else {
          this.$toast.fail(res.message)
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.wofo {
    with:60px;
    height:40px;
    text-align:center
}
</style>
